
<div *ngIf="list && list.length === 0" class="zero-ui" [ngClass]="{'zero-ui-small':'small'==size}">
  <i nz-icon [nzType]="icon" nzTheme="outline"></i>
  <h2>{{title}}</h2>
  <p>{{message}}</p>
</div>
